import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import moment from 'moment'
import iconDownload from 'images/icon-download.svg'
import { formatCPF, formatCNPJ, formatAlphanumericCNPJ, isAlphanumericCNPJ } from 'utils/masks'

class ModalLog extends Component {
  get orderTitle() {
    const { log } = this.props

    switch (true) {
      case !!log.orderNumber:
        return 'query.logs.modal.orderNumber'

      case !!log.documentNumber:
        return 'query.logs.modal.documentNumber'

      default:
        return ''
    }
  }

  formatDocument(number) {
    const { translate } = this.props

    if (!number) {
      return number
    }

    if (isAlphanumericCNPJ(number)) {
      return formatAlphanumericCNPJ(number)
    }

    switch (number.length) {
      case 11:
        return formatCPF(number, translate)
      case 14:
        return formatCNPJ(number, translate)
      default:
        return number
    }
  }

  render() {
    const { translate, closeModal, tableFiltered, getTxt, log } = this.props

    return (
      <Modal closeModal={closeModal}>
        <div className='modal-query-log'>
          <div>
            <strong>{translate('totem.query.logs.modal.functionality')}</strong>
            <p>{translate(tableFiltered)}</p>
          </div>

          <div className='modal-div-data'>
            <div className='modal-div-date'>
              <strong>{translate(this.orderTitle)}</strong>
              <p>{log.orderNumber || this.formatDocument(log.documentNumber)}</p>
            </div>

            <div className='modal-div-hour'>
              <strong className='strong-label'>
                {translate('query.logs.modal.endpoint')}
              </strong>
              <p className='strong-label'>
                {log.endpoint ? log.endpoint : '-'}
              </p>
            </div>
          </div>

          <div className='modal-div-data'>
            <div className='modal-div-date'>
              <strong>{translate('query.logs.modal.date')}</strong>
              <p>{moment(log.creatTs).format('l')}</p>
            </div>

            <div className='modal-div-hour'>
              <strong className='strong-label'>
                {translate('query.logs.modal.hour')}
              </strong>
              <p className='strong-label'>{moment(log.creatTs).format('LT')}</p>
            </div>
          </div>

          <div className='modal-query-content'>
            <strong>{translate('query.logs.modal.request')}</strong>
            <p>{log.dsRequest}</p>
          </div>

          <div className='modal-query-content'>
            <strong>{translate('query.logs.modal.response')}</strong>
            <p>{log.dsResponse}</p>
          </div>

          <div className='modal-query-btn-down'>
            <strong className='modal-query-btn-onClick' onClick={getTxt}>
              {translate('query.logs.modal.download')}
            </strong>
            <img
              onClick={getTxt}
              className='modal-query-btn-down-img modal-query-btn-onClick'
              src={iconDownload}
            />
          </div>

          <div style={{ marginLeft: '20%' }}>
            <button
              onClick={closeModal}
              style={{ width: '75%' }}
              className='button button-primary'
            >
              {translate('query.logs.modal.close')}
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default ModalLog

ModalLog.propTypes = {
  translate: PropTypes.func,
  closeModal: PropTypes.func,
  log: PropTypes.object,
  tableFiltered: PropTypes.string,
  getTxt: PropTypes.func,
}
